import Swiper from 'swiper/bundle';
import 'swiper/css';

export default (element, data) => {
  const init = () => {
    const buildSwiperSlider = (sliderElm) => {
      const perView = sliderElm.dataset.columns;
      return new Swiper(`#${sliderElm.id}`, {
        slidesPerView: 1.2,
        spaceBetween: 1,
        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
          960: {
            slidesPerView: perView,
          },
        },
      });
    };

    // Get all of the swipers on the page
    const allSliders = document.querySelectorAll('.featured-swiper');

    // Loop over all of the fetched sliders and apply Swiper on each one.
    allSliders.forEach((slider) => buildSwiperSlider(slider));
  };

  init();
};
